<template>
    <!-- navbar -->
    <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">
        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->
        <img :src="'/imgs/tallyLogo4.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Features</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Pricing
                        </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Blog</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Faq's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">Support</a>
                </li>
            </ul>
        </div> 

        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <div class="flex justify-between mr-4">
              <div class="flex justify-between space-x-2">
                <img :src="'/imgs/tally_header.png'" class="img-fluid " alt="" >
                  <div class="flex flex-col ml-2">
                    <div>
                      <h6 class=" text-xs font-semibold text-gray-400" >
                          hotline 24/7
                      </h6>
                    </div>
                  <div>
                    <h6 class=" text-xs text-gray-700 font-bold">
                        (+91)9263637575
                    </h6>
                  </div>
                          
                </div>
              </div>
              </div> 
            </ul>
             <button type="button" id="button" class=" md:py-1 py-1 mr-2 px-3 rounded-md  text-white" style="background-color: #07528E;">Get Free</button>     
        </div> 
  </nav>
    <!-- navbar --> 
    
      <!-- faq start  -->
       
        <main class="site-wrapper container mt-5">
            <div class="grid grid-cols-2 gap-4">
  <div>
    <h3 class="mt-3 font-bold" style="color:#07528E">Answer to your question</h3>
  </div>
  <!-- ... -->
  <div class="flex justify-end ">
   <p class="mt-3 font-bold ">Have a question? <span style="color:#f5ab0f">Ask now</span></p>
  </div>
</div>
	

	<div class="accordion my-5">
		<div class="accordion__item">
			<h2 class="accordion__title active">This is a FAQ Accordion Title 001</h2>
			<div class="accordion__body">
				<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repudiandae amet quidem error blanditiis architecto molestiae recusandae fugit fugiat, et reprehenderit ratione perferendis quia. Vitae in molestiae, dicta doloribus porro quaerat.</p>
			</div>
		</div>
		<!-- 	END Item -->
		<div class="accordion__item">
			<h2 class="accordion__title">This is a FAQ Accordion Title 002</h2>
			<div class="accordion__body">
				<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repudiandae amet quidem error blanditiis architecto molestiae recusandae fugit fugiat, et reprehenderit ratione perferendis quia. Vitae in molestiae, dicta doloribus porro quaerat.</p>
			</div>
		</div>
		<!-- 	END Item -->
		<div class="accordion__item">
			<h2 class="accordion__title">This is a FAQ Accordion Title 003</h2>
			<div class="accordion__body">
				<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repudiandae amet quidem error blanditiis architecto molestiae recusandae fugit fugiat, et reprehenderit ratione perferendis quia. Vitae in molestiae, dicta doloribus porro quaerat.</p>
			</div>
		</div>
		<!-- 	END Item -->
		<div class="accordion__item">
			<h2 class="accordion__title">This is a FAQ Accordion Title 004</h2>
			<div class="accordion__body">
				<p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repudiandae amet quidem error blanditiis architecto molestiae recusandae fugit fugiat, et reprehenderit ratione perferendis quia. Vitae in molestiae, dicta doloribus porro quaerat.</p>
			</div>
		</div>
		<!-- 	END Item -->
	</div>
	<!-- 	END Accordion -->
        </main>

         <!-- footer start -->
    <div>
        <footer class="section bg-footer section-main-container">
          <div class="container">
              <div class="row">
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Get our app</h6>
  
                          <div class="">
                              <a href=""><img
                                      src="/imgs/gp.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                              <a href=""> <img
                                      src="/imgs/gp2.png"
                                      class="footer-download-icon img-fluid mt-2"></a>
                          </div>
                      </div>
                  </div>
  
                  <div class="col-lg-3">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Resources</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-2">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Help</h6>
                          <ul class="list-unstyled footer-link">
                              <li><a href="">Menu 1</a></li>
                              <li><a href="">Menu 2</a></li>
                              <li><a href="">Menu 3</a></li>
                              <li><a href="">Menu 4</a></li>
                          </ul>
                      </div>
                  </div>
  
                  <div class="col-lg-4">
                      <div class="">
                          <h6 class="footer-heading text-uppercase text-white">Contact Us</h6>
                          <table>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-envelope contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; abc@aruvaa.com</p>
                                  </td>
                              </tr>
                              <tr>
                                  <td style="text-align: center; vertical-align: middle;">
                                      <i class="fas fa-mobile-alt contact-info-icon"></i>
                                  </td>
                                  <td>
                                      <p class="mt-2 contact-info-data"> &nbsp; +01 123-456-7890</p>
                                  </td>
                              </tr>
                          </table>
  
   </div>
                  </div>
  
              </div>
          </div>
  
          <div class="text-center mt-5 container">
              <hr class="footer-hr">
              <div class="d-flex justify-content-center below-hr-container">
                  <a href=""><span>Privary Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Terms of use</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Cookie Privacy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Abuse Policy</span></a>
                  <span class="ml-3 mr-3">|</span>
                  <a href=""><span>Anti-spam Policy</span></a>
              </div>
              <p class="footer-alt mb-0 f-14 mt-2">2019 © Aruvaa, All Rights Reserved</p>
          </div>
      </footer>
    </div>
    <!-- footer end -->
            
</template>

<script>
 export default {
    mounted(){
     // faq's
     $(".accordion__title.active").next().slideDown();
$(".accordion__title").on("click", function () {
  if( $(this).hasClass('active') ) {
		$(this).removeClass("active").next().slideUp();
	} else {
		$(".accordion__title.active").removeClass("active").next(".accordion__body").slideUp();
    $(this).addClass('active').next('.accordion__body').slideDown();
	}
});
  
    }
 }
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: none;
}
h6{
margin-bottom: 0.1rem;
}
.img_size{
 height: auto;
 width: 156px;
}
.nav-link-header {
     color: #9c761f !important;
     font-weight: 650 !important;
     font-size: 16px;
 }
 .navbar {
  position: relative;
  display: flex;
  align-items: center; 
  padding: .5rem 5rem;
}
@media  only screen and (max-width: 758px) {
    .navbar {
  padding: .5rem 1rem;
}
      }
      @media only screen and (max-width: 992px) {
    .navbar {
  padding: .5rem 1rem;
}
  }
/* faq's css start */
.accordion__item {
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  /* box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.06); */
}
.accordion__body {
  display: none;
  padding-top: 10px;
}
.accordion__body p {
  margin-bottom: 0;
}
.accordion__title {
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 0;
  position: relative;
}
.accordion__title:after {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
  background: url("/imgs/arrow.png");
  /* background-size: 20px; */
}
.accordion__title.active {
  color: #07528e;
}
.accordion__title.active:after {
  transform: rotate(-180deg);
}
/* footer css start */
.bg-footer {
          background-color: #33383c;
          padding: 50px 0 30px;
      }
      .footer-heading {
          letter-spacing: 2px;
      }
      .footer-link a {
          color: #ffffff;
          font-size: 14px;
          transition: all 0.2s;
          text-decoration: none;
      }
      .footer-link a:hover {
          color: #FDC031;
          text-decoration: none;
      }
      .contact-info {
          color: #ffffff;
          font-size: 14px;
      }
      .footer-alt {
          color: #818282;
          font-size: 12px;
      }
      .footer-heading {
          position: relative;
          padding-bottom: -12px !important;
      }
      .footer-heading:after {
          content: '';
          width: 25px;
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
      }
      .contact-info-icon {
          color: #ffffff;
          font-size: 16px;
      }
      .contact-info-data {
          color: #ffffff;
          font-size: 16px;
          margin: 0px 0px 0px !important;
      }
      /* Extra small devices (phones, 600px and down) */
      @media  only screen and (max-width: 648px) {
          .footer-download-icon {
              width: 36%;
          }
          .banner_img{
         display: none;
      }
      }
      /* Small devices (portrait tablets and large phones, 600px and up) */
      @media  only screen and (min-width: 648px) {
          .footer-download-icon {
              width: 36%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
  
      }
      /* Medium devices (landscape tablets, 768px and up) */
      @media  only screen and (min-width: 768px) {
          .footer-download-icon {
              width: 40%;
          }
          .carousel-content {
    transition: width .4s;
    height: 80%;
  }
         
      }
      /* Large devices (laptops/desktops, 992px and up) */
      @media  only screen and (min-width: 992px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
          transition: width .4s;
          height: 60%;
        }
 
      }
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      @media  only screen and (min-width: 1200px) {
          .footer-download-icon {
              width: 54%;
          }
          .carousel-content {
    transition: width .4s;
    height: 60%;
  }
 
      }
      .footer-get-trial-button {
          background: #FDC031;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 6px;
          padding-bottom: 6px;
          font-weight: bold;
          border-radius: 4px;
          border: none;
          color: #333;
          text-align: center;
          margin-top: 10px;
          font-weight: 500;
          transition: all 0.5s;
          cursor: pointer;
      }
      .footer-hr {
          border-color: #404447;
          background-color: #404447;
          color: #404447;
      }
      .below-hr-container {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a {
          color: #818282;
          font-size: 12px;
      }
      .below-hr-container a:hover {
          text-decoration: none;
      }
  /* footer css end */
</style>